import _get from 'lodash/get'
import { computed, ref, provide, inject } from '@vue/composition-api'

export function initFieldDiffs ({ condition, label, diffList, displayDiffInReadMode = true, modalDescription }) {
  provide('dynamic_form_diff_condition', condition)
  provide('dynamic_form_diff_list', diffList)
  provide('dynamic_form_diff_label', label)
  provide('dynamic_form_display_diff_in_read_mode', displayDiffInReadMode)
  provide('dynamic_form_diff_modal_description', modalDescription)
}

export default function useFieldDiffs ({ field, questionPath = [], valuePath = [] } = {}) {
  const diffCondition = inject('dynamic_form_diff_condition', () => false)
  const property = field.value.dataKey || field.value.questionId || field.value.key
  const questionPathWithProperty = [ ...questionPath, property ].join('.')
  const isDiffingActive = diffCondition(field.value, questionPathWithProperty)
  if (!isDiffingActive) {
    return {
      isDiffingActive: false,
      fieldDiffs: [],
      proposalFieldsDiffs: { value: {} },
      baseValue: { value: {} },
      displayDiffInReadMode: true,
    }
  }

  const diffList = inject('dynamic_form_diff_list', ref([]))
  const diffLabel = inject('dynamic_form_diff_label', (field) => field.name)
  const displayDiffInReadMode = inject('dynamic_form_display_diff_in_read_mode', true)
  const valuePathWithProperty = [ ...valuePath, property ].join('.')

  const fieldDiffs = computed(() => {
    if (!isDiffingActive) return []

    return diffList.value.map(diff => {
      let potentialValue = _get(diff, valuePathWithProperty, undefined)
      // as potentialValue can be false, we should look further only if it's undefined
      if (potentialValue === undefined) {
        potentialValue = _get(
          diff.customFields || {},
          valuePathWithProperty,
          undefined
        )
      }

      return {
        label: diffLabel(diff),
        property: questionPathWithProperty,
        value: potentialValue,
        formValue: diff,
      }
    })
  })
  const proposalFieldsDiffs = computed(() => fieldDiffs.value
    .filter(diff => diff.formValue.requestStatus === 'pending'))

  const baseValue = computed(() => fieldDiffs.value
    .find(diff => diff.formValue.requestStatus !== 'pending') || { formValue: {} })

  return {
    isDiffingActive,
    displayDiffInReadMode,
    fieldDiffs,
    proposalFieldsDiffs,
    baseValue,
  }
}
